import { createSelector } from 'reselect';
import { getDoctorsPiState } from './index';
import { API_CALL_STATUS, FORM_STATUS } from '../../reducers/status';

export const getPersonalDetails = createSelector(getDoctorsPiState, (state) => state.personalDetails);

const makeGetPersonalDetailsField = (fieldName) =>
    createSelector(getPersonalDetails, (personalDetails) => personalDetails[fieldName]);

export const getPersonalDetailsId = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails.personalDetailId
);

export const getPersonalDetailsForm = makeGetPersonalDetailsField('form');

export const getPersonalDetailsFormValid = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails.formStatus === FORM_STATUS.VALID
);

export const getIsApiPending = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails.apiCallStatus === API_CALL_STATUS.PENDING
);

export const getApiStatus = createSelector(getPersonalDetails, (personalDetails) => personalDetails.apiCallStatus);

const makeGetFieldForm = (fieldId) => createSelector(getPersonalDetailsForm, (form) => form[fieldId]);

export const getFirstNameValue = makeGetFieldForm('firstName');
export const getSurnameValue = makeGetFieldForm('surname');
export const getDobValue = makeGetFieldForm('dob');
export const getEmailValue = makeGetFieldForm('email');
export const getMobileNumberValue = makeGetFieldForm('mobileNumber');
export const getIdPassportValue = makeGetFieldForm('idPassport');
export const getKraPinNumberValue = makeGetFieldForm('kraPinNumber');
export const getCityValue = makeGetFieldForm('city');
export const getStreetAddressValue = makeGetFieldForm('streetAddress');
export const getBuildingValue = makeGetFieldForm('building');
export const getPostalCodeValue = makeGetFieldForm('postalCode');
export const getPostalBoxValue = makeGetFieldForm('postalBox');
export const getReferredValue = makeGetFieldForm('referred');
